import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";

import "./success-indicator.scss";

const block = "success-indicator";

const SuccessIndicator = ({ children, title, className, ...rest }) => (
  <div className={cn(block, className)} {...rest}>
    <FontAwesomeIcon
      icon={faCheckCircle}
      aria-hidden={true}
      className={`${block}__icon`}
    />
    <h1 className={`${block}__header`}>{title}</h1>
    {children}
  </div>
);

SuccessIndicator.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default SuccessIndicator;
